(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var live;
  function announce(message) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 50);
  }
  function updateCartCount(count) {
    document.querySelectorAll('.cart-link').forEach(function (link) {
      var bubble = link.querySelector('.cart-count');
      if (!bubble && count > 0) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count';
        link.appendChild(bubble);
      }
      if (!bubble) return;
      if (count > 0) {
        bubble.textContent = count;
        bubble.setAttribute('aria-label', count + (count === 1 ? ' item' : ' items'));
      } else {
        bubble.remove();
      }
    });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-quick-add]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-quick-add-label]');
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add this item.');
          return data;
        });
      })
      .then(function (item) {
        button.classList.add('is-added');
        label.textContent = 'Added';
        announce('Added to cart: ' + item.product_title + '.');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function (error) {
        label.textContent = 'Try again';
        announce(error.message);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        window.setTimeout(function () {
          button.classList.remove('is-added');
          label.textContent = 'Add to cart';
        }, 2200);
      });
  });
})();
